function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import cx from "classnames";
import { twMerge } from "../../../utils/twMerge";
export function Heading(props) {
    var tmp = props.as, As = tmp === void 0 ? "div" : tmp, variant = props.variant, className = props.className, children = props.children, rest = _objectWithoutProperties(props, [
        "as",
        "variant",
        "className",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(As, _extends({
        className: twMerge(cx(variant === "h1" && "font-medium leading-normal text-h1.small md:text-h1.base whitespace-pre-line", variant === "h1+" && "font-medium leading-normal text-h1.small md:text-h1.large whitespace-pre-line", variant === "h2" && "font-medium leading-normal text-h2.small md:text-h2.base whitespace-pre-line", variant === "h3" && "font-medium leading-normal text-h3.small md:text-h3.base whitespace-pre-line", variant === "h3s" && "font-medium leading-normal text-h3s.small md:text-h3s.base whitespace-pre-line", variant === "h4" && "font-medium leading-normal text-h4.base whitespace-pre-line", variant === "h5" && "font-medium leading-normal text-h5.small md:text-h5.base whitespace-pre-line", variant === "h6" && "font-medium leading-normal text-h6.small md:text-h6.base whitespace-pre-line", className))
    }, rest), children);
}

//# sourceMappingURL=Heading.js.map